export default {
	install: (Vue) => {
		Vue.prototype.$VtigerGetSession = function(response) {
			let vm = this;
			this.$VtigerCall('get', 'token', {}, (data, success) =>{
				if (success) {
					vm.$APICall('post', 'login', {token: data.token}, (data, success) => {
						if (success) {
							vm.$myStore.commit('setUser', data.user);
							vm.$myStore.commit('setLoggedIn', true);
							if (data.version !== vm.$getCookie('ide3_version')) {
								vm.$setCookie('ide3_version', data.version);
								window.location.reload(true);
							}
						}
						response(success);
					});
				} else {
					response(false);
				}
			});
		};
		Vue.prototype.$VtigerCall = function (method, service, data, responseCall, showLoader = true, files = null) {
			if (files == null) {
				let properties = {
					method: method,
					url: this.$getSettings('VTIGER_BASE') + service,
					json: true,
					withCredentials: true
				};
				if ((method == 'put') || (method == 'post') || (method == 'patch')) {
					properties.data = data;
				} else {
					properties.params = data;
				}
				if (showLoader) {
					this.$myStore.commit('increaseLoaderCount');
				}

				let vm = this;
				this.axios(properties).then(function (response) {
					if (showLoader) {
						vm.$myStore.commit('decreaseLoaderCount');
					}
					responseCall(response.data, true);
				}, function (error) {
					if (showLoader) {
						vm.$myStore.commit('decreaseLoaderCount');
					}
					responseCall(error.response.data, false);
				});
			} else {
				let formData = new FormData();

				for (let key in files) {
					formData.append(key, files[key]);
				}

				for (let key in data) {
					if (typeof (data[key]) != 'object') {
						formData.append(key, data[key]);
					} else {
						formData.append(key, JSON.stringify(data[key]));
					}
				}

				if (showLoader) {
					this.$myStore.commit('increaseLoaderCount');
				}

				let vm = this;
				this.axios({
					method: method,
					url: this.$getSettings('VTIGER_BASE') + service,
					data: formData,
					headers: {
						'Content-Type': 'multipart/form-data'
					},
					withCredentials: true
				}).then(function (response) {
					if (showLoader) {
						vm.$myStore.commit('decreaseLoaderCount');
					}
					responseCall(response.data, true);
				}, function (error) {
					if (showLoader) {
						vm.$myStore.commit('decreaseLoaderCount');
					}
					responseCall(error.response.data, false);
				});
			}
		};
	}
};
